import { useEffect, useState } from 'react';
import {
  subscribeResponsibles,
  type ResponsibleListResult,
} from '@/lib/firestoreResponsibles';

/**
 * Hook que envolve `subscribeResponsibles` em estado React. `LOADING` no
 * primeiro tick, `READY`/`ERROR` em seguida. Limpa o listener no unmount e
 * quando `tenantId` muda. *
 * Origem: sem issue — commit f948c64e4, 2026-06-10 18:39 +0200.
 *
 * Usado por: `features/responsibles/ResponsiblesTab.tsx`.
 *
 * Dados: `tenants/{tenantId}/responsibles`, validado por `ResponsibleSchema` em
 * `lib/firestoreResponsibles.ts`.
 *
 * Falhas conhecidas: documento fora do schema é descartado no `lib/` só com
 * `console.warn`, e erro do listener só com `console.error` — nenhum dos dois
 * chega à telemetria (CLAUDE.md "Observabilidade"; ver #926, achados).
 */
export function useResponsibles(tenantId: string): ResponsibleListResult {
  const [result, setResult] = useState<ResponsibleListResult>({ kind: 'LOADING' });

  useEffect(() => {
    if (!tenantId) {
      setResult({ kind: 'LOADING' });
      return;
    }
    setResult({ kind: 'LOADING' });
    const unsub = subscribeResponsibles(tenantId, setResult);
    return unsub;
  }, [tenantId]);

  return result;
}
